class RevealerCompare extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector('[data-revealer-container]');
    this.overlay = this.querySelector('[data-revealer-overlay]');
    this.handle = this.querySelector('[data-revealer-handle]');
    if (!this.container || !this.overlay || !this.handle) return;

    this.position = parseFloat(this.dataset.start) || 50;
    this.dragging = false;

    this.onMove = this.onMove.bind(this);
    this.onUp = this.onUp.bind(this);
    this.syncWidth = this.syncWidth.bind(this);

    this.handle.addEventListener('pointerdown', (e) => this.onDown(e));
    this.container.addEventListener('pointerdown', (e) => {
      if (e.target === this.handle || this.handle.contains(e.target)) return;
      this.setFromEvent(e);
    });

    this.handle.addEventListener('keydown', (e) => this.onKeydown(e));

    this.observer = new ResizeObserver(this.syncWidth);
    this.observer.observe(this.container);

    this.syncWidth();
    this.apply();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('pointermove', this.onMove);
    window.removeEventListener('pointerup', this.onUp);
  }

  syncWidth() {
    const w = this.container.getBoundingClientRect().width;
    if (w > 0) this.style.setProperty('--revealer-frame-width', `${w}px`);
  }

  onDown(event) {
    event.preventDefault();
    this.dragging = true;
    this.classList.add('is-dragging');
    window.addEventListener('pointermove', this.onMove);
    window.addEventListener('pointerup', this.onUp);
  }

  onMove(event) {
    if (!this.dragging) return;
    this.setFromEvent(event);
  }

  onUp() {
    this.dragging = false;
    this.classList.remove('is-dragging');
    window.removeEventListener('pointermove', this.onMove);
    window.removeEventListener('pointerup', this.onUp);
  }

  setFromEvent(event) {
    const rect = this.container.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    this.position = Math.min(100, Math.max(0, x));
    this.apply();
  }

  onKeydown(event) {
    const step = { ArrowLeft: -4, ArrowRight: 4, Home: -100, End: 100 }[event.key];
    if (step === undefined) return;
    event.preventDefault();
    this.position = Math.min(100, Math.max(0, this.position + step));
    this.apply();
  }

  apply() {
    this.style.setProperty('--revealer-position', `${this.position}%`);
    this.handle.setAttribute('aria-valuenow', Math.round(this.position));
  }
}

if (!customElements.get('revealer-compare')) {
  customElements.define('revealer-compare', RevealerCompare);
}
